import styles from "../Footer/Footer.module.css";
import { PortableText } from "@portabletext/react";

const Footer = ({ fetchFooterdata }) => {
  if (!fetchFooterdata) return null;
  const ptComponents = {
    marks: {
      purple: ({ children }) => (
        <span style={{ color: "#6524EB" }}>{children}</span>
      ),
      strong: ({ children }) => <strong>{children}</strong>,
      break: ({ children }) => (
        <>
          {children}
          <br />
        </>
      ),
    },
    list: {
      bullet: ({ children }) => <ul className="list-disc ml-6">{children}</ul>,
      number: ({ children }) => (
        <ol className="list-decimal ml-6">{children}</ol>
      ),
    },
  };
  const { brand, socialLinks, linkGroups } = fetchFooterdata;
  return (
    <div className={styles.containerBox}>
      <div className={styles.container}>
        <div className={styles.LeftBar}>
          <div className={styles.Logodiv}>
            <img
              src={brand?.logo?.src}
              alt={brand?.logo?.alt || "footer-logo"}
            />
          </div>
          <div className={styles.desc}>
            <p>
              <PortableText value={brand?.line} components={ptComponents} />
              {/* Your <span className={styles.Boldtext}>24/7 AI receptionist</span>{" "}
              – answering, connecting, and growing your business. */}
            </p>
          </div>
          <div className={styles.socialIon}>
            <div className={styles.right}>
              {socialLinks?.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target={social.newTab ? "_blank" : "_self"}
                  rel="noopener noreferrer"
                >
                  <img
                    src={social.icon?.src}
                    alt={social.icon?.alt || "social"}
                  />
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className={styles.RightBar}>
          <div className={styles.footer}>
            {linkGroups?.map((group, groupIndex) => (
              <div className={styles.column} key={groupIndex}>
                <h4>{group.title}</h4>
                <ul>
                  {group.links?.map((lnk, index) => (
                    <li key={index}>
                      {lnk.href ? (
                        <a
                          className={styles.footerLink}
                          href={lnk.href}
                          target={lnk.newTab ? "_blank" : "_self"}
                        >
                          {lnk.label}
                        </a>
                      ) : (
                        lnk.label
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={styles.BottomLogo}>
        <img src="/Images/rexpt-bootm-logo.png" alt="rexpt-bootm-logo" />
      </div>
    </div>
  );
};

export default Footer;
